(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 99133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(37514);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PageContent; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(80051);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(7583);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(82621);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(94646);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(88349);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/system/dist/index.esm.js + 3 modules
var index_esm = __webpack_require__(88975);
// EXTERNAL MODULE: ../../node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48157);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(34885);
// EXTERNAL MODULE: ./components/NavBar.tsx + 2 modules
var NavBar = __webpack_require__(47795);
;// CONCATENATED MODULE: ./components/BaseLayout.tsx




function BaseLayout(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        flexDir: [
            "column",
            null,
            "row"
        ],
        paddingBottom: [
            "".concat(NavBar/* NAVBAR_MOBILE_HEIGHT */.Q3, "px"),
            null,
            0
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                order: [
                    2,
                    null,
                    1
                ],
                h: [
                    "auto",
                    null,
                    "100vh"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBar/* default */.ZP, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                order: [
                    1,
                    null,
                    2
                ],
                as: "main",
                w: [
                    "100%",
                    null,
                    "calc(100% - ".concat(NavBar/* NAVBAR_WIDTH */.aO, "px)")
                ],
                h: [
                    "auto",
                    null,
                    "100vh"
                ],
                children: children
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(73070);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var icons_dist_index_esm = __webpack_require__(34548);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(52803);
// EXTERNAL MODULE: ./utils/scroll.ts
var utils_scroll = __webpack_require__(24393);
;// CONCATENATED MODULE: ./components/MoveTopNavigator.tsx







function MoveTopNavigator(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "MoveTopNavigator",
        w: "40px",
        h: "40px",
        position: "fixed",
        zIndex: 3000,
        bottom: [
            "80px",
            "100px",
            "24px"
        ],
        right: "24px"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
            w: "100%",
            h: "100%",
            bgColor: "gray.700",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_dist_index_esm/* ChevronUpIcon */.g8, {}),
            "aria-label": "상단으로 이동",
            onClick: function() {
                return (0,utils_scroll/* moveTop */.p)();
            }
        })
    }));
};

;// CONCATENATED MODULE: ./components/PageContent.tsx









function PageContent(_param) {
    var className = _param.className, _padding = _param.padding, padding = _padding === void 0 ? [
        "8px",
        "16px",
        "24px"
    ] : _padding, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "padding",
        "children"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,index_esm/* useToken */.dQ)("colors", [
        "gray.900"
    ]), 1), gray900 = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseLayout, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoveTopNavigator, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: [
                    className,
                    "PageContent"
                ].join(" "),
                h: [
                    "auto",
                    null,
                    "100vh"
                ],
                overflowY: [
                    null,
                    null,
                    "scroll"
                ],
                position: "relative",
                padding: padding
            }, props), {
                css: {
                    "&::-webkit-scrollbar": {
                        width: "8px"
                    },
                    "&::-webkit-scrollbar-track": {
                        width: "6px"
                    },
                    "&::-webkit-scrollbar-thumb": {
                        background: gray900,
                        borderRadius: "24px"
                    }
                },
                children: children
            }))
        ]
    });
};


/***/ }),

/***/ 37514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ NotFoundPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48157);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _components_PageContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69856);
// @ts-ignore

// @ts-ignore



var __N_SSG = true;
function NotFoundPage() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
            w: "100%",
            h: "100%",
            justifyContent: "center",
            alignItems: "cernter",
            children: "404 Not Found!"
        })
    });
};
 // @ts-ignore


/***/ }),

/***/ 24393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ moveTop; }
/* harmony export */ });
var moveTop = function() {
    var top = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, behavior = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "smooth";
    // Note: 데스크탑 사이즈인 경우 main이 100vh라 PageContent 스크롤을 핸들링 해야함
    var $content = matchMedia("screen and (min-width: 768px)").matches ? document.querySelector(".PageContent") : window;
    $content.scroll({
        left: 0,
        top: top,
        behavior: behavior
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4847,4424,6525,5789,8917,2123,4285,2445,4887,2748,7795,9774,2888,179], function() { return __webpack_exec__(99133); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);